import { Link, getRouteApi } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { ButtonGroup, IconName, Page, PageFace } from 'ui/components'
import { Button, IconButton } from 'ui/components/Buttons'
import { BreadCrumbs } from 'ui/temp'
import { useChangeTemplateStatus } from '~bank-document-templates/hooks'
import { DocTemplateDetails } from '~bank-document-templates/types'

import { TemplatesSideBar } from '../../components'
import { Details, Footer, History } from './components'
import { TemplatesDetailsContext } from './context'

const routeApi = getRouteApi('/_app/document-templates/$id')

export default () => {
  const data = routeApi.useLoaderData() as DocTemplateDetails
  const { name, canActivate, canDeactivate, id } = data
  const { openStatusChangeConfirmation } = useChangeTemplateStatus()

  return (
    <TemplatesDetailsContext.Provider value={{ routeApi, data }}>
      <Page
        title="Template"
        subTitle={name}
        face={PageFace.SECONDARY}
        breadCrumbs={
          <BreadCrumbs
            links={[
              <Link to={routes.bank.documents.index}>Documents</Link>,
              <Link to={routes.bank.documentTemplates.index}>Template Manager</Link>,
              <>{name}</>
            ]}
          />
        }
        actions={
          <ButtonGroup margin="big">
            {canActivate && (
              <IconButton icon={IconName.ACTIVATE} onClick={() => openStatusChangeConfirmation({ id, active: false })}>
                Activate
              </IconButton>
            )}
            {canDeactivate && (
              <IconButton icon={IconName.SNOWFLAKE} onClick={() => openStatusChangeConfirmation({ id, active: true })}>
                Deactivate
              </IconButton>
            )}
            <Link to={routes.bank.documentTemplates.manage} params={{ id: '0' }} search={{ copyFrom: id }}>
              <Button face="inherit white">Duplicate</Button>
            </Link>
          </ButtonGroup>
        }
        footer={<Footer />}
      >
        <TemplatesSideBar historyEnabled />
        <Details />
        <History />
      </Page>
    </TemplatesDetailsContext.Provider>
  )
}
